<script lang="ts">import { isSearchDropdownOpen } from '../SearchDropdown.svelte';
import { activeFlyoutStore } from '../../../../../js-v2/stores/flyout-stores';
import { activeDropdownStore } from '../../../../../js-v2/stores/desktop-nav-stores';
import { onTouchOrClick } from '../../../../../js-v2/onTouchOrClick';
</script>

<div
  class="Scrim"
  class:isVisible={$activeFlyoutStore?.enableScrim || $activeDropdownStore.id !== null || $isSearchDropdownOpen}
  style:visibility="var(--scrim-visibility, hidden)"
  aria-hidden="true"
  use:onTouchOrClick={activeDropdownStore.close}
></div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Scrim {
  display: none;
}
@media (min-width: 64rem) {
  .Scrim {
    box-sizing: border-box;
    z-index: 2;
    display: block;
    position: fixed;
    inset: 0;
    background-color: var(--color-scrim-background);
    opacity: 0;
    backdrop-filter: blur(16px);
    --scrim-visibility: hidden;
    pointer-events: none;
    transition: pointer-events 0ms, visibility 0ms 200ms, opacity 200ms cubic-bezier(0.4, 0, 1, 1);
  }
  .Scrim.isVisible {
    opacity: 1;
    --scrim-visibility: visible;
    pointer-events: auto;
    transition: visibility 0ms, pointer-events 0ms 250ms, opacity 250ms cubic-bezier(0, 0, 0.2, 1);
  }
}</style>
